import axios from 'axios'
import { getCredentials } from '@/helpers/credentials'
import { ADMIN_CREDENTIALS_STORAGE_KEY } from '@/constants/auth'
import * as types from './types'

let kpiClient
const getKpiClientInstance = () => {
  if (!kpiClient) {
    kpiClient = axios.create({
      baseURL: process.env.VUE_APP_KPI_ENDPOINT,
      withCredentials: false,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
      },
    })

    // Add interceptor to dynamically add token on each request
    kpiClient.interceptors.request.use(
      config => {
        const credentials = getCredentials(ADMIN_CREDENTIALS_STORAGE_KEY)
        if (credentials?.token) {
          config.headers.Authorization = `Bearer ${credentials.token}`
        }
        return config
      },
      error => Promise.reject(error)
    )
  }
  return kpiClient
}

export default {
  [types.OPEN_NEW_CAMPAIGN_KPI_SIDEBAR]: ({ commit }, payload) => {
    commit(types.MUTATE_NEW_CAMPAIGN_KPI_SIDEBAR, {
      ...payload,
      visible: true,
    })
  },
  [types.GET_CONSULTANTS]: ({ commit }, payload) => axios
    .get('/api/consultants/summary', { params: payload })
    .then(resp => {
      commit(types.MUTATE_CONSULTANTS, resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  [types.STORE_CAMPAIGN_KPI]: ({ }, payload) => getKpiClientInstance()
    .post('/api/campaign', payload)
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.UPDATE_CAMPAIGN_KPI]: ({ }, payload) => {
    const resource = `/api/campaign/${payload.id}`
    delete payload.id
    return getKpiClientInstance()
      .put(resource, payload)
      .then(resp => Promise.resolve(resp))
      .catch(err => Promise.reject(err))
  },
  [types.DELETE_CAMPAIGN_KPI]: ({ }, payload) => getKpiClientInstance()
    .delete(`/api/campaign/${payload}`)
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.GET_CAMPAIGNS_KPI]: ({ commit }, payload) => getKpiClientInstance()
    .get('/api/campaign', { params: payload })
    .then(resp => {
      commit(types.MUTATE_NEW_CAMPAIGN_KPI_ARRAY, resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  [types.GET_CAMPAIGN_KPI]: ({ }, payload) => getKpiClientInstance()
    .get(`/api/campaign/${payload}`)
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.GET_CONSULTANT_AND_CHILDS]: ({ commit }, payload = {}) => {
    const { skipCommit, ...params } = payload

    return getKpiClientInstance()
      .get('/api/consultant_performance/table', {
        params: {
          ...params,
          snapshotMode: params.snapshotMode || 'live',
        },
      })
      .then(resp => {
        if (!skipCommit) {
          commit(types.MUTATE_KPI_LIST, resp.data)
        }
        return Promise.resolve(resp)
      })
      .catch(err => Promise.reject(err))
  },
  [types.GET_KPI_SNAPSHOT_RANGES]: (_, payload = {}) => getKpiClientInstance()
    .get('/api/consultant_performance/snapshot_ranges', {
      params: {
        ...payload,
        snapshotMode: payload.snapshotMode || 'live',
      },
    })
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.GET_LEADS_PERFOMANCE]: ({ commit }, payload) => getKpiClientInstance()
    .get('/api/consultant_performance/leads', { params: payload })
    .then(resp => {
      commit(types.MUTATE_KPI_LIST_CONTENT, resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  [types.GET_HOT_LEADS_PERFOMANCE]: ({ commit }, payload) => getKpiClientInstance()
    .get('/api/consultant_performance/hot_leads', { params: payload })
    .then(resp => {
      commit(types.MUTATE_KPI_LIST_CONTENT, resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  [types.GET_APPOINTMENTS_PERFORMANCE]: ({ commit }, payload) => getKpiClientInstance()
    .get('/api/consultant_performance/appointments', { params: payload })
    .then(resp => {
      commit(types.MUTATE_KPI_LIST_CONTENT, resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  [types.GET_APPOINTMENT_REPORTS_PERFORMANCE]: ({ commit }, payload) => getKpiClientInstance()
    .get('/api/consultant_performance/appointment_reports', {
      params: payload,
    })
    .then(resp => {
      commit(types.MUTATE_KPI_LIST_CONTENT, resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  [types.GET_INTERVIEWS_PERFORMANCE]: ({ commit }, payload) => getKpiClientInstance()
    .get('/api/consultant_performance/interviews', { params: payload })
    .then(resp => {
      commit(types.MUTATE_KPI_LIST_CONTENT, resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  [types.GET_CONTRACTS_PERFORMANCE]: ({ commit }, payload) => getKpiClientInstance()
    .get('/api/consultant_performance/contracts', { params: payload })
    .then(resp => {
      commit(types.MUTATE_KPI_LIST_CONTENT, resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  [types.GET_DNA_CAMPAING]: _ => getKpiClientInstance()
    .get('/api/consultant_dna')
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.GET_DNA_PROGRESS]: _ => getKpiClientInstance()
    .get('/api/consultant_dna/progress')
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.GET_DNA_ANUAL_PROGRESS]: _ => getKpiClientInstance()
    .get('/api/consultant_dna/anual_progress')
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.GET_CAMPAIGNS_KPI_FILTERED]: (_, payload) => getKpiClientInstance()
    .get('/api/consultant_dna', { params: payload })
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.TOGGLE_CAMPAIGN_VISIBILITY]: (_, campaignId) => getKpiClientInstance()
    .patch(`/api/campaign/${campaignId}/toggle-visibility`)
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  // O esqueleto da árvore, sem número. Não depende de período: só dos filtros de
  // inativos. O backend cacheia por 30 min, então pedir de novo ao trocar de
  // competência custa pouco — mas a tela também não precisa pedir.
  [types.GET_CONSULTANT_STRUCTURE]: (_, payload = {}) => getKpiClientInstance()
    .get('/api/consultant_performance/structure', { params: payload })
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  // Detalhamento de UMA célula, nas duas perspectivas (`attribution`). Exige
  // consultantId de propósito: nunca é um dump da estrutura. Escopado a um
  // consultor custa 0,45s; o audit inteiro, 23s.
  [types.GET_CONTRACT_DETAIL]: (_, payload) => getKpiClientInstance()
    .get('/api/consultant_performance/contract_detail', { params: payload })
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
}
